import { render } from "./NotificationsView.vue?vue&type=template&id=deca3cc6"
import script from "./NotificationsView.vue?vue&type=script&lang=js"
export * from "./NotificationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__